export default __webpack_public_path__ + "static/app-8accd7ba36310725d5e9df19193adedf.png";